import blankProfile from "media/blank_profile.png";

import { useSelector } from "react-redux";
import React from "react";

import IStore from "models/IStore";
import RoleEnum from "constants/RoleEnum";
import IUserCookieModel from "models/common-models/IUserCookieModel";

import "./ProfileMedia.css";

const ProfileMedia: React.FC = () => {
  const user: IUserCookieModel | null = useSelector((state: IStore) => state.auth.user);
  const selectedProfileState: string | undefined = useSelector((state: IStore) => state.auth.selectedProfile);

  const nameFormatter = (name: string): string => {
    if (name.length > 30) {
      return name.substring(0, 30) + "...";
    }
    return name;
  };

  // Compute image and name directly from user and selectedProfileState
  let image: string | null = null;
  let name: string | undefined = undefined;

  if (user) {
    if (selectedProfileState === RoleEnum.Actor) {
      image = user.avatar;
      name = user.first_name;
    } else if (selectedProfileState === RoleEnum.CastAgency) {
      image = user.companies.cast_agency?.logo ?? "";
      name = user.companies.cast_agency?.name ?? "";
    } else if (selectedProfileState === RoleEnum.ProductionCompany) {
      image = user.companies.production_company?.logo ?? "";
      name = user.companies.production_company?.name ?? "";
    } else if (selectedProfileState === RoleEnum.Client) {
      image = user.companies.client?.logo ?? "";
      name = user.companies.client?.name ?? "";
    } else {
      image = user.avatar;
      name = user.first_name;
    }
  }

  return (
    <span className="media profile-media">
      <span className="item-img">
        <img src={image || blankProfile} alt="Chat" />
      </span>
      <span className="media-body">
        <span className="item-title">{nameFormatter(name ?? "")}</span>
      </span>
    </span>
  );
};

export default ProfileMedia;
